import dayjs from "@/services/dayjs";
import store from "@/services/localStorage/storage";

const KEY = "lastPwaPrompt";

function hide() {
  store.set(KEY, dayjs().format());
}

function canShow() {
  if (navigator.standalone) {
    return false;
  }

  let today = dayjs();

  let days = Number.MAX_SAFE_INTEGER;

  let lastPrompt = store.get(KEY);
  if (lastPrompt) {
    days = today.diff(dayjs(lastPrompt), "day");
  }

  let isApple = ["iPhone", "iPad", "iPod"].includes(navigator.platform);
  return (isNaN(days) || days > 14) && isApple;
}

export { hide, canShow };
